import { makeVar } from '@apollo/client'
import { v4 as uuidv4 } from 'uuid'
import { MessageType } from 'ts/enums/messageType.enums'

export type alertQueueType = {
  id?: number | string
  pauseAutoHideProp?: boolean
  message?: string
  type?: MessageType
  onClose?: () => void
  onOk?: () => void
}

export const alertQueueVar = makeVar<alertQueueType[]>([])

export const popAlertQueue = (alertId: number) => {
  const alertQueue = alertQueueVar()

  alertQueueVar(alertQueue.filter((alert: alertQueueType) => alert.id !== alertId))
}
export const setAlertQueue = (incomingAlert: alertQueueType) => {
  const alertQueue = alertQueueVar()

  const hasAlreadyIncomingAlert = alertQueue?.find(
    (alert: alertQueueType) => alert.message === incomingAlert.message
  )

  const queue: alertQueueType[] = hasAlreadyIncomingAlert
    ? [...alertQueue]
    : [...alertQueue, { ...incomingAlert, id: uuidv4() }]

  alertQueueVar(queue)
}

export const clearAlertQueue = () => {
  alertQueueVar([])
}
